import { request } from '@@/plugin-request';

export async function queryContracts(params) {
  return request('/api/datacenter/pool/contracts', {
    method: 'POST',
    data: params,
  });
}
